import { NgModule } from "@angular/core";
import { FabPageHomepagesComponent } from "./fab-page-homepages.component";
import { ButtonItemComponent } from "./button-item/button-item.component";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import { MenuWorkflowModule } from "../../../workflow/menu-workflow/menu-workflow.module";
import { MMIconsModule } from "mm-ui";
import { PermissionMenuModule } from "../permission-menu/permission-menu.module";
import { FabComponent } from './fab/fab.component';
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    declarations: [
        FabPageHomepagesComponent,
        ButtonItemComponent,
        FabComponent
    ], exports: [
        FabPageHomepagesComponent,
        ButtonItemComponent,
        FabComponent
    ], imports: [
        CommonModule,
        MenuWorkflowModule,
        MatButtonModule,
        MatTooltipModule,
        MMIconsModule,
        PermissionMenuModule,
        TranslateModule
    ]
})
export class FabPageHomepagesModule{}
